<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        archive: function(response){
             if (response==1){
                this.errors = [];
                this.messageIdToast = null;
                let state = this;
                Request.do(this, 'PUT', Request.getDefaultHeader(this), this.data, `${Endpoints.alerts.closeAlert}${this.data._id ? this.data._id : ''}`,
                    (companyResponse)=>{//SUCCESS CALLBACK
                        // location.reload();
                        this.clearForm();
                $('#spinner').modal('toggle');

                    },
                    (error)=>{//ERROR CALLBACK
                        $('#spinner').modal('toggle');
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                        console.log(JSON.stringify(error));
                });
            }
     



        },
        confirmArchive: function(item){
            this.titleToast = this.$t("string.msg.menu.alert.panic.label.close.title");
            this.messageToast = this.$t("string.msg.menu.alert.panic.label.close.description");
            this.cancelText = this.$t("string.msg.cancel");
            this.yesText = this.$t("string.msg.yes");
            $('#confirmationModal').modal('show');
        },
        selectItem: function(item){
            this.data = JSON.parse(JSON.stringify(item));
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        clearForm: function(){
            this.data = {};
        },
      
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
